import { render, staticRenderFns } from "./SalesPerSegmentReport.vue?vue&type=template&id=19f19fa5&"
import script from "./SalesPerSegmentReport.vue?vue&type=script&lang=js&"
export * from "./SalesPerSegmentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports